// Next Action panel for the Plan page rail.
import { Collapse } from '@mui/material';
import Panel from '@/components/ui/Panel';
import TaskList from '@/features/tasks/components/lists/TaskList';
import { useT } from '@/i18n/useT';
import {
  PANEL_FLAT_CLASS,
  PLAN_PANEL_A11Y,
  planRailListTabProps,
  railListProps,
} from '@/features/planning/components/shared/planRailPanelShared';

export default function PlanRailNextActionPanel({
  showNextAction,
  nextActions,
  nextActionRailSlice,
  selectedTaskIds,
  railSelectionHandlers,
  focusOwnerId,
  nextActionHighlightId,
  projectStateProps,
}) {
  const t = useT();
  return (
    <Collapse in={showNextAction} timeout={220} unmountOnExit>
      <Panel
        flat
        contentClassName={PANEL_FLAT_CLASS}
        testId="panel-next-action"
        title={t('plan.nextAction', 'Next Actions')}
        count={nextActions.length}
        {...PLAN_PANEL_A11Y}
      >
        <TaskList
          tasks={nextActionRailSlice}
          selectedTaskIds={selectedTaskIds}
          onSelectionChange={railSelectionHandlers['next-action']}
          listId="next-action"
          focusOwnerId={focusOwnerId}
          onboardingHighlightTaskId={nextActionHighlightId}
          {...railListProps}
          {...projectStateProps}
          {...planRailListTabProps(nextActionRailSlice)}
        />
      </Panel>
    </Collapse>
  );
}
